package com.milta.core.localization.translations.pl

import com.milta.core.localization.RouteCreationStrings

internal val RouteCreation = RouteCreationStrings(
    newRouteTitle = "Nowa trasa",
    stepDeliveries = "Dostawy",
    stepDrivers = "Kierowcy",
    stepDistribution = "Podział",
    deliveriesSummary = "%1 dostaw · %2 paczek",
    deliveriesSummaryOne = "1 dostawa · %1 paczek",
    toFixCount = "%1 do poprawy",
    allAddressesCorrect = "Wszystkie adresy są poprawne",
    filterAll = "Wszystkie %1",
    filterToFix = "Do poprawy %1",
    fixAddressesToContinue = "Popraw %1 adresy, aby kontynuować",
    fixOneAddressToContinue = "Popraw 1 adres, aby kontynuować",
    continueWithDeliveries = "Dalej · %1 dostaw",
    continueWithOneDelivery = "Dalej · 1 dostawa",
    chooseAtLeastOneDriver = "Wybierz co najmniej jednego kierowcę",
    reasonMissingHouseNumber = "Brak numeru domu",
    reasonNotFound = "Nie znaleziono adresu",
    reasonUnverified = "Nie udało się sprawdzić, spróbuj ponownie",
    missingHouseNumberExample = "Brakuje numeru domu. Przykład: %1",
    notFoundHelp = "Nie znaleziono adresu. Sprawdź ulicę, numer i kod pocztowy.",
    unverifiedHelp = "Nie udało się teraz sprawdzić adresu. Spróbuj ponownie za chwilę.",
    addToExistingHint = "Zostaną dodane do %1 dostaw, które są już na liście.",
    importFileAction = "Importuj plik",
    importFileHint = "Excel (.xlsx, .xls), CSV lub PDF",
    manualEntryAction = "Wprowadzanie ręczne",
    manualEntryHint = "Nazwa, adres, telefon, godzina graniczna",
    addDeliveryTitle = "Dodaj dostawę",
    deleteDelivery = "Usuń dostawę",
    addedFileAnalysing = "Analiza pliku %1…",
    addedFileFailed = "Import pliku %1 nie powiódł się. Nie dodano żadnej dostawy.",
    errorAddressesToFix = "Niektóre adresy nie zostały zweryfikowane: popraw je na liście „Do poprawy”.",
    errorAddressesCheckRetry = "Sprawdzanie adresów nie powiodło się. Spróbuj ponownie za chwilę.",
    errorBatchAlreadyDispatched = "Ten podział został już wysłany do kierowców.",
    editDeliveryTitle = "Edytuj dostawę",
    zoneLabel = "Strefa %1",
    workloadBalanced = "Czas pracy kierowców jest wyrównany",
    workloadGap = "Różnica czasu pracy między kierowcami: %1",
    importAddedFromScan = "Dodano %1 dostaw ze skanu",
    importAddedOneFromScan = "Dodano 1 dostawę ze skanu",
    importAddedFromPdf = "Dodano %1 dostaw z PDF",
    importAddedOneFromPdf = "Dodano 1 dostawę z PDF",
    importAddedFromSpreadsheet = "Dodano %1 dostaw z pliku Excel",
    importAddedOneFromSpreadsheet = "Dodano 1 dostawę z pliku Excel",
    importAddedToFixSuffix = ", w tym %1 do poprawy",
    deliverySearchOpenAction = "Szukaj dostawy",
    deliverySearchCount = "%1 z %2",
    deliverySearchCountToFix = "%1 z %2 do poprawy",
    deliverySearchEmptyTitle = "Brak pasujących dostaw",
    deliverySearchEmptyToFixHint = "Brak pasujących dostaw do poprawy. Spróbuj w „Wszystkie”.",
)
